import { put, select } from 'redux-saga/effects';
import { getSelectedTimelines } from '../../../selectors';
import { fetchExtensionEntry } from '../../timelineEntries/fetchExtensionEntries';
import { selectExtensionPeriodEntriesSaga } from '../../../selectors-saga';
import { ExtensionTimelineEntry } from '../../../../../../../../common/types/timeline/ExtensionPeriodEntryType';
import { scheduleActions } from '../../../actions';
import { PusherActionType, PusherReduxAction } from '../../../../../../../../redux/pusher/PusherActions';

export function* handleExtensionPeriodEntryUpdate(action: PusherReduxAction<PusherActionType.EXTENSION_PERIOD_UPDATED>) {
  const selectedTimelines = yield select(getSelectedTimelines);
  if (!selectedTimelines || selectedTimelines.length === 0 || !action.payload) return;

  const entryId = action.payload;

  const fullEntry = yield* fetchExtensionEntry(entryId);
  const entries = yield* selectExtensionPeriodEntriesSaga();
  const updatedEntries = entries.map((entry: ExtensionTimelineEntry) =>
    entry.ID === entryId ? fullEntry : entry,
  );

  yield put(scheduleActions.setExtensionPeriodTimelineEntries(updatedEntries));
}
